module.exports = __webpack_public_path__ + "static/media/home-page-view.9ac993ca.png";